import { of } from "rxjs";
import { debounceTime, filter, switchMap } from "rxjs/operators";
import { selectIsModalOpen } from "../../selectors/selectModalTabId";
import { actionModalClose, actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { TypeActionNetwork } from "../network/actionNetwork";
export var epicDisconnect = function (action$, state$) {
    return action$.pipe(filter(function (action) {
        return (action.type === TypeActionNetwork.Connected ||
            action.type === TypeActionNetwork.Disconnected) &&
            !selectIsModalOpen(state$.value, IdModal.DisconnectedByLogin) &&
            !selectIsModalOpen(state$.value, IdModal.Maintenance);
    }), debounceTime(5000), switchMap(function (action) {
        var actions = action.type === TypeActionNetwork.Disconnected
            ? actionModalOpen(IdModal.Disconnect)
            : actionModalClose(IdModal.Disconnect);
        return of(actions);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/disconnect-dialog/epicDisconnect.ts
// module id = 1829
// module chunks = 3